import styled from 'styled-components';
export const SrOnly = /*#__PURE__*/styled.span.withConfig({
  displayName: "SrOnly",
  componentId: "sc-3hvdi4-0"
})(["position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0;"]);
SrOnly.displayName = 'SrOnly';